import React from 'react'

import { renderRichTextWithHTML } from '../../logic/contentful'
import { IContentfulTable } from '../../logic/shared-types'

import './BlogSection.scss'

export const Table = ({ section }: { section: IContentfulTable }) => {
  const { body, footnotes } = section
  return (
    <div className="richText blogSection__richText blogSection__richText--table">
      {renderRichTextWithHTML({ text: body })}
      {footnotes ? (
        <div className="richText__footnotes">
          {renderRichTextWithHTML({ text: footnotes })}
        </div>
      ) : null}
    </div>
  )
}
